const config = {
  siteTitle: "Maureen Augras, Sophrologue à Nice",
  siteUrl: "https://www.maureenaugras.com",
  userName: "Maureen AUGRAS",
  userEmail: "contact@maureenaugras.com",
  userEmailUrl: "mailto:contact@maureenaugras.com",
  userCalendy: "Prendre rendez-vous",
  userCalendyUrl: "https://calendly.com/sophrologue-nice",
  userCellPhone: "+33 6 30 26 83 69",
  userCellPhoneUrl: "tel:+33630268369",
  pathPrefix: "/",
  siteDescription:
    "Maureen Augras, sophrologue et hypnothérapeute à Nice, formée à l'INES à Paris, diplômée SFS. Gestion du stress, gestion des émotions, anxiété, angoisses, phobies, préparation à la maternité, trouble du sommeil ou de l'alimentation, confiance en soi, mieux-être, ...",
  userAddress: {
    name: "Nice",
    street: "18 avenue Malaussena",
    city: "06000 NICE",
    googleMaps: "https://maps.app.goo.gl/98FutkZx5XoDMCz59",
  },
  Facebook:
    " https://www.facebook.com/people/Maureen-Augras-Sophrologue/100063581522223/ ",
  Instagram: "https://www.instagram.com/maureenaugras/",
  Twitter: "https://twitter.com/MaureenAugras",
  Linkedin: "https://www.linkedin.com/in/maureenaugrassophrologue",
  userBackLinks: [
    {
      label: "Syndicat des Sophrologues Professionnels",
      url: "https://www.syndicat-sophrologues-professionnels.fr/missions-du-ssp.html",
    },
    {
      label: "Société Française de Sophrologie",
      url: "https://www.sophrologie-francaise.com/",
    },
    {
      label: "Code de déontologie",
      url: "https://www.syndicat-sophrologues-professionnels.fr/le-metier-de-sophrologue.html",
    },
    {
      label: "Annuaire Santé",
      url: "https://www.annuairesante.com/sophrologue/lille-59000",
    },
    {
      label: "Hoodspot",
      url: "https://hoodspot.fr/autres-professionnels-de-sante/maureen-augras-sophrologue-et-hypnotherapeute-81753169200017/",
    },
    {
      label: "Proxi Bien être",
      url: "https://www.proxibienetre.fr/acteur-bien-etre/11093",
    },
    {
      label: "Je Suis Sophrologue",
      url: "https://www.jesuissophrologue.fr/profil/26",
    },
  ],
};

module.exports = config;
